import { render, staticRenderFns } from "./OrderPdfReport.vue?vue&type=template&id=28a87d08&scoped=true&"
import script from "./OrderPdfReport.vue?vue&type=script&lang=js&"
export * from "./OrderPdfReport.vue?vue&type=script&lang=js&"
import style0 from "./OrderPdfReport.vue?vue&type=style&index=0&id=28a87d08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a87d08",
  null
  
)

export default component.exports